import React from 'react'
import { Icon, useIsMobile } from '@amzn/storm-ui'
import { MobilePreviousButtonContainer, MobileNextButtonContainer, DesktopPreviousButtonContainer, DesktopNextButtonContainer } from './styles'
import { useLaunchModalContext } from '../../../contexts/LaunchModalContext'

const pageDirection = document.documentElement.dir
const nextIconType = pageDirection !== 'rtl' ? 'left' : 'right'
const prevIconType = pageDirection !== 'rtl' ? 'right' : 'left'

export const PreviousButton: React.VFC<{
  label: string
  isMobile?: boolean
}> = ({ label, isMobile = false }) => {
  const { dataTaktId, previousSlide } = useLaunchModalContext()
  const mobileFromTheme = useIsMobile()
  const StyledPreviousButtonContainer = isMobile || mobileFromTheme ? MobilePreviousButtonContainer : DesktopPreviousButtonContainer
  return (
    <StyledPreviousButtonContainer onClick={() => previousSlide()} aria-label={label}>
      <span data-takt-id={`${dataTaktId}_previous-button`}>
        <Icon type={`chevron-${nextIconType}`} size="2x" />
      </span>
    </StyledPreviousButtonContainer>
  )
}

export const NextButton: React.VFC<{
  label: string
  isMobile?: boolean
}> = ({ label, isMobile = false }) => {
  const { dataTaktId, nextSlide } = useLaunchModalContext()
  const mobileFromTheme = useIsMobile()
  const StyledNextButtonContainer = isMobile || mobileFromTheme ? MobileNextButtonContainer : DesktopNextButtonContainer
  return (
    <StyledNextButtonContainer onClick={() => nextSlide(true)} aria-label={label}>
      <span data-takt-id={`${dataTaktId}_next-button`}>
        <Icon type={`chevron-${prevIconType}`} size="2x" />
      </span>
    </StyledNextButtonContainer>
  )
}
